/**
 * Filename: 插件、组件
 * Created Date:2021/9/6
 * Author: pyh
 *
 * Copyright (c) 2021 Your Company
 */

import Vue from 'vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


// import viSelectFile from '@/components/vi-select-file.vue'; // 选择文件
// import viRadio from '@/components/vi-radio.vue'; // 按钮选中组件
// import viLoading from '@/components/vi-loading.vue'; // loading
// import viAvatar from '@/components/vi-avatar.vue'; // 用户头像组件
// import viNoData from '@/components/vi-nodata.vue'; // 暂无数据
// import viUpdate from '@/components/vi-update.vue'; // 更新软件
// import viDownloadTip from '@/components/vi-download-tip.vue'; // 下载视频提示框
// import viVideoPlayer from '@/components/vi-video-player.vue'; // 视频播放组件
// import viTimeLine from '@/components/vi-timeline.vue'; // 时间轴组件
// import viMore from '@/components/vi-more.vue'; // more 组件
// import viTeamSelect from '@/components/vi-team-select.vue'; // 梯队下拉列表

// const components = [
//     viSelectFile,
//     viRadio,
//     viLoading,
//     viAvatar,
//     viNoData,
//     viUpdate,
//     viDownloadTip,
//     viVideoPlayer,
//     viTimeLine,
//     viMore,
//     viTeamSelect
// ];
// components.forEach(component => {
//     Vue.component(component.name, component);
// });